import React, { useEffect, useState } from 'react';

import { CharacterSheetInterface } from "@dndModels";
import { AbilityScoreType } from '@dndModels/Types';

import FlexBox from '@components/layout/FlexBox';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { ABILITY_SCORES, ONES_0_to_50, PROFICIENCY_OPTIONS } from '@dndModels/Constants';

interface Props {
  char: CharacterSheetInterface;
}

export default function CharacterSavingThrowCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [editing_stat, setEditingStat] = useState<AbilityScoreType | "">("");
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderSavingThrowCustomization = (ability_score: AbilityScoreType) => {
    // debugger;
    return (
      <>
        <FlexBox direction="column" className="clickable" style={{ width: "33%" }} onClick={() => setEditingStat(ability_score) }>
          <FlexBox className="header">
            { ability_score }: Current { char.mind.saving_throws[ability_score].modifier }
          </FlexBox>
          { (char.mind.saving_throws[ability_score]) && 
            <FlexBox className="small_label gray">{ (char.mind.saving_throws[ability_score].proficiency === 1 ? "Proficient" : (char.mind.saving_throws[ability_score].proficiency === 2 ? "Expert" : (char.mind.saving_throws[ability_score].proficiency === 0.5 ? "Half Proficient" : ""))) }</FlexBox>
          }
          { customizations.prof_overrides[ability_score] && Object.keys(customizations.prof_overrides[ability_score]).length > 0 &&
            <FlexBox className="small_label gray">(Overridden)</FlexBox>
          }
        </FlexBox>
      </>
    );
  }

  const renderSelectedField = () => {
    if (editing_stat) {
      return (
        <>
          <FlexBox>Customizations for { editing_stat }</FlexBox>
          <FlexBox direction="row">
            <FlexBox style={{ width: "25%" }}>
              <SelectStringBox
                name="Proficiency Level"
                value={ customizations.prof_overrides[editing_stat] && customizations.prof_overrides[editing_stat].prof_level !== undefined ? `${customizations.prof_overrides[editing_stat].prof_level}` : "Don't Override" }
                options={PROFICIENCY_OPTIONS}
                extra_options={["Don't Override"]}
                label_above
                onChange={(changed: string) => {
                  if (changed === "Don't Override") {
                    delete customizations.prof_overrides[editing_stat].prof_level;
                  } else {
                    if (!customizations.prof_overrides[editing_stat]) {
                      customizations.prof_overrides[editing_stat] = {};
                    }
                    customizations.prof_overrides[editing_stat].prof_level = +changed;
                  }
                  setPing(!ping);
                  char.changed();
                  char.subscription_holder.recalculate();
                }}
              />
            </FlexBox>
            <FlexBox style={{ width: "25%" }}>
              <SelectStringBox
                name="Use Ability Score"
                value={ customizations.prof_overrides[editing_stat] && customizations.prof_overrides[editing_stat].stat_override !== undefined ? customizations.prof_overrides[editing_stat].stat_override : "Don't Override" }
                options={ABILITY_SCORES}
                extra_options={["Don't Override"]}
                label_above
                onChange={(changed: AbilityScoreType | "Don't Override") => {
                  if (changed === "Don't Override") {
                    delete customizations.prof_overrides[editing_stat].stat_override;
                  } else {
                    if (!customizations.prof_overrides[editing_stat]) {
                      customizations.prof_overrides[editing_stat] = {};
                    }
                    customizations.prof_overrides[editing_stat].stat_override = changed;
                  }
                  setPing(!ping);
                  char.changed();
                  char.subscription_holder.recalculate();
                }}
              />
            </FlexBox>
            <FlexBox style={{ width: "25%" }}>
              <SelectStringBox
                name="Override"
                value={ customizations.prof_overrides[editing_stat] && customizations.prof_overrides[editing_stat].override !== undefined ? `${customizations.prof_overrides[editing_stat].override}` : "Don't Override" }
                options={["-5","-4","-3","-2","-1",...ONES_0_to_50]}
                extra_options={["Don't Override"]}
                label_above
                onChange={(changed: string) => {
                  if (changed === "Don't Override") {
                    delete customizations.prof_overrides[editing_stat].override;
                  } else {
                    if (!customizations.prof_overrides[editing_stat]) {
                      customizations.prof_overrides[editing_stat] = {};
                    }
                    customizations.prof_overrides[editing_stat].override = +changed;
                  }
                  setPing(!ping);
                  char.changed();
                  char.subscription_holder.recalculate();
                }}
              />
            </FlexBox>
            <FlexBox style={{ width: "25%" }}>
              <SelectStringBox
                name="Bonus"
                value={ customizations.prof_overrides[editing_stat] && customizations.prof_overrides[editing_stat].bonus !== undefined ? `${customizations.prof_overrides[editing_stat].bonus}` : "Don't Override" }
                options={["-5","-4","-3","-2","-1",...ONES_0_to_50]}
                extra_options={["Don't Override"]}
                label_above
                onChange={(changed: string) => {
                  if (changed === "Don't Override") {
                    delete customizations.prof_overrides[editing_stat].bonus;
                  } else {
                    if (!customizations.prof_overrides[editing_stat]) {
                      customizations.prof_overrides[editing_stat] = {};
                    }
                    customizations.prof_overrides[editing_stat].bonus = +changed;
                  }
                  setPing(!ping);
                  char.changed();
                  char.subscription_holder.recalculate();
                }}
              />
            </FlexBox>
          </FlexBox>
        </>
      );
    }
    return null;
  }

  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      <FlexBox direction="row" style={{ width: "100%" }}>
        { renderSavingThrowCustomization("STR") }
        { renderSavingThrowCustomization("DEX") }
        { renderSavingThrowCustomization("CON") }
      </FlexBox>
      <FlexBox direction="row" style={{ width: "100%" }}>
        { renderSavingThrowCustomization("INT") }
        { renderSavingThrowCustomization("WIS") }
        { renderSavingThrowCustomization("CHA") }
      </FlexBox>
      { renderSelectedField() }
    </FlexBox>
  );
}

